import { render, staticRenderFns } from "./BindLog.vue?vue&type=template&id=67382cb7&scoped=true"
import script from "./BindLog.vue?vue&type=script&lang=ts"
export * from "./BindLog.vue?vue&type=script&lang=ts"
import style0 from "./BindLog.vue?vue&type=style&index=0&id=67382cb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67382cb7",
  null
  
)

export default component.exports